import { RatePlanPolicy } from '../../types/rateplanPolicy'
import PolicyRowSkeleton from './RatePlanPolicyListRow.skeleton'
import RatePlansPoliciesListRow from './RatePlansPoliciesListRow'
import RatePlansPoliciesListTableHead from './RatePlansPoliciesListTableHead'

interface RatePlansPoliciesListProps {
  data: RatePlanPolicy[] | undefined
  loading: boolean
  reloadData: () => void
}
const RatePlansPoliciesList: React.FC<RatePlansPoliciesListProps> = ({
  data,
  loading,
  reloadData
}) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  return (
    <>
      <div>
        <RatePlansPoliciesListTableHead reloadData={reloadData} />
      </div>
      <div>
        {loading
          ? Array(8)
              .fill('')
              .map((item, index) => (
                <PolicyRowSkeleton
                  key={`accommodation-skeleton${item}${index.toString()}`}
                />
              ))
          : data?.map((item: RatePlanPolicy) => (
              <RatePlansPoliciesListRow policiesData={item} />
            ))}
      </div>
    </>
  )
}
export default RatePlansPoliciesList
